import axios from "axios";

const B_URL = process.env.REACT_APP_LOGINURL

const getPublicDocument = (id) => {
    var payload = {
        functionName: "GetPublicDocument",
        postData: {
            _id: id,
        },
    }
    return axios.post(B_URL + 'DocumentsRoutes/GetPublicDocument', payload);
};

const getPublicConfigDocument = (configDoc) => {
    var payload = {
        functionName: "GetPublicConfigDocument",
        postData: {
            config_doc: configDoc,
        },
    }
    return axios.post(B_URL + 'DocumentsRoutes/GetPublicConfigDocument', payload);
};

const TrainingMaterialService = {
    getPublicDocument,
    getPublicConfigDocument,
};

export default TrainingMaterialService;
